import Image from 'next/image';
import React, { useMemo } from 'react';
import { CarClass } from '@/entities/car-class';
import { useLocale } from '@/shared/hooks/use-locale';
import { tp } from '@/shared/lib/typograf';

type Props = React.HTMLAttributes<HTMLElement> & {
    car: CarClass;
};

export default function CarListCard({ car }: Props) {
    const locale = useLocale();

    const tpName = useMemo(() => tp(car.name || '', locale), [car.name, locale]);
    const tpBrands = useMemo(() => tp(car.brands || '', locale), [car.brands, locale]);

    return (
        <div className="car-list-card">
            <Image
                src={car.image.src}
                className="car-list-card__image responsive__item"
                height={car.image.height}
                width={car.image.width}
                alt={car.image.alt || ''}
                sizes="(max-width: 1199px) 100vw, 30vw"
            />

            <div className="car-list-card__content">
                {car.name && <p className="car-list-card__title text-xl">{tpName}</p>}
                {car.brands && <p className="car-list-card__description text-s">{tpBrands}</p>}
            </div>
        </div>
    );
}
